import { render, staticRenderFns } from "./116wlpsyh.vue?vue&type=template&id=6d278c84&"
import script from "./116wlpsyh.vue?vue&type=script&lang=js&"
export * from "./116wlpsyh.vue?vue&type=script&lang=js&"
import style0 from "./116wlpsyh.vue?vue&type=style&index=0&id=6d278c84&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports